export const GTAG_ID = 'G-PYGEM3FXRQ'
